'use client';

import type { PropsWithChildren } from 'react';
import { useAccountVersion } from '../contexts/ActiveAccountIdContext/useAccountVersion';

/**
 * Prevents rendering children until we know this account is version 4+
 */
export const VersionGate = ({ children }: PropsWithChildren) => {
  const accountVersion = useAccountVersion();

  if (!accountVersion || accountVersion < 4) return null;

  return <>{children}</>;
};
